import apiClient from "../apiClient";

const resource = "SalaryDoctorsReport";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    createSettlement: (paylod) => apiClient.post(`${resource}`,paylod),
    getDoctors: () => apiClient.get(`${resource}/doctors`),

};
